import React, { useEffect, useState } from 'react';
import { Grid, ThemeProvider } from '@material-ui/core';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { AttachFile } from '@material-ui/icons';
import useStyles from './SubirArchivoVoluntarioStyle';
import { InputDescripcion, texts } from './SubirArchivoVoluntarioData';
import Input from '../../commons/input/Input';
import useVoluntarioPDF from './SubirArchivoVoluntarioFunction'; // Importamos la lógica de los hooks
import VisualizadorPdf from 'components/commons/visualizadorPdf/VisualizadorPdf';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import { pasosNuevaSolicitud, compProperties, properties as appProperties } from './../../../AppData';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import useOperations from '../subirArchivo/SubirArchivoFunction';

export default function SubirArchivoVoluntario(props) {
    const { updateFormat, isPhoneVersion, mostrarPDF, cerrarPopUpPdf, abrirPopUpPdf, cortarTexto, mostrarTextoEntero, mostrarTexto } = useVoluntarioPDF();
    const {getMaxFileSize,getMimeType,getSafeFileName, getPreviewImage, buildAcceptAttribute} =useOperations();
    const { customStyle, overInputs } = useStyles(isPhoneVersion);
    const style = customStyle();
    const [previewImg, setPreviewImg] = useState(props.img || null);
    const [imageMaxSize, setImageMaxSize] = useState(props.tamMaximoArchivo * 1000000 || null);
    const estiloContenedor = props.styleGridContenedor === null ? style.clasGridContenedor : props.styleGridContenedor;
    const acceptedFiles = buildAcceptAttribute(props.formato);
    const [poderVerPdf, setPoderVerPdf] = useState(false);

   const handleFileDrop = (files, rejectedFiles) => {
     if (files.length > 0) {
       const wrapper = files[0];
       const file = wrapper.file; //file real
       const fileName = getSafeFileName(wrapper);
       if (!fileName) return props.handleRejection([file]);

       const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
       setPoderVerPdf(ext === '.pdf');

       const mimeType = getMimeType(ext);
       if (!mimeType) return props.handleRejection([file]);

       const maxSize = getMaxFileSize(ext, props.tamMaximoArchivo); // debe devolver 500 * 1024 * 1024
       const bytesToMB = maxSize / (1024 * 1024);
       setImageMaxSize(bytesToMB);

       if (file.size > maxSize) return props.handleRejection([file]);

       const imgPath = getPreviewImage(ext);
       setPreviewImg(imgPath);

       // Pasar wrapper (con base64) solo para PDF, sino solo el File
       if (ext === '.pdf') {
         props.handleOnDrop([wrapper], rejectedFiles);
       } else {
         props.handleOnDrop([file], rejectedFiles);
       }
     }
   };



    useEffect(() => {
        updateFormat();
        window.addEventListener('resize', updateFormat);
        return () => window.removeEventListener('resize', updateFormat);
    }, [updateFormat]);

    return (
        <Grid className={style.classGridContenedor} disabled={true}>
            {props.mostrarDocAnexo && (
                <Grid>
                    {mostrarTexto ? (
                        <Grid className={style.classDivIcon} onClick={mostrarTextoEntero}>
                            <KeyboardArrowDownIcon className={style.classIcon} />
                            <p title={props.value} className={style.classTextoEntero}>
                                {props.value}
                            </p>
                        </Grid>
                    ) : (
                        <Grid className={style.classDivIcon} onClick={mostrarTextoEntero}>
                            <KeyboardArrowRightIcon className={style.classIcon} />
                            <p title={props.value} className={style.classTextoCortado}>
                                {cortarTexto(props.value)}
                            </p>
                        </Grid>
                    )}
                    <Grid className={style.classGridImg}>
                        <img src={previewImg} className={style.classImg} />
                        <p className={style.classParrafo}>
                            {texts.TAM}
                            {props.tamDoc}
                            {texts.PESO}
                        </p>
                    </Grid>
                    <button className={style.classButtonCancelar} name={props.value} onClick={props.bottonFunction}>
                        {texts.ELIMINAR}
                    </button>
                    {poderVerPdf && props.poderVisualizar && (
                        <button className={style.classButtonVer} name={props.value} onClick={abrirPopUpPdf}>
                            {texts.VER}
                        </button>
                    )}
                </Grid>
            )}

            {!props.mostrarDocAnexo && (
                <ThemeProvider theme={overInputs}>
                    <Input
                        classes={style}
                        {...InputDescripcion}
                        id={props.id !== undefined && props.id !== null ? props.id : InputDescripcion.id}
                        value={props.value}
                        onChange={props.onChange}
                        disabled={props.isDisabled}
                    />
                    {props.mostrarDrop && (
                        <DropzoneAreaBase
                            Icon={AttachFile}
                            acceptedFiles={acceptedFiles}
                            dropzoneText={texts.TEXTO_DROP}
                            filesLimit={1}
                            onAdd={handleFileDrop} // Usamos el nuevo handler aquí
                            maxFileSize={imageMaxSize}
                            onDropRejected={props.handleRejection}
                            showAlerts={[]}
                        />
                    )}
                </ThemeProvider>
            )}

            {/* Confirmar para mostrar PDF */}
            <Confirmacion
                accionConfirmacion={cerrarPopUpPdf}
                mostrar={mostrarPDF}
                isPhoneVersion={isPhoneVersion}
                mensaje={<VisualizadorPdf pdf={props.pdf} isPhoneVersion={isPhoneVersion} pdfNombre={props.value} />}
                botonera={compProperties.SOLO_CERRAR}
                quitarImg={true}
                tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_0}
                isPopUpPdf={true}
                textBotonConfirmarPersonalizado={false}
                isImagenPersonalizada={false}
                centrarContenido={true}
                isTextoEnriquecido={false}
            />
        </Grid>
    );
}